import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SvgIcon from '~src/shared/SvgIcon';
import { translateError } from '~src/services/translationServices';
import {
  HeaderInputContainer,
  InputSection,
  FixedText,
  InputField,
  ErrorMessage,
} from '~src/modules/okrs/manageObjectives/shared/repetition/headerInput.sc';

interface Props {
  locked?: boolean;
  isSelected?: boolean;
  error?: string;
  onSelect?: () => void;
  onBlur?: () => void;
  placeholder: string;
  value?: string | number;
  defaultValue?: string | string[];
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TitleInput: FC<Props> = ({
                                 defaultValue,
                                 error,
                                 inputRef,
                                 isSelected,
                                 locked,
                                 onBlur,
                                 onChange,
                                 onSelect,
                                 placeholder,
                                 value,
}) => {
  const [t] = useTranslation();

  return (
    <InputSection>
      <HeaderInputContainer $isSelected={isSelected} $error={error}>
        {locked ? (
          <FixedText>{value || defaultValue}</FixedText>
        ) : (
          <InputField
            ref={inputRef}
            data-translation={placeholder}
            $hasValue={!!value || !!defaultValue}
            placeholder={t(placeholder)}
            onChange={onChange}
            onSelect={onSelect}
            onBlur={onBlur}
            value={value || defaultValue}
          />
        )}

        {error && <SvgIcon name="iconInfoIFilled" />}
      </HeaderInputContainer>
      {error && <ErrorMessage>{translateError(t, error)}</ErrorMessage>}
    </InputSection>
  );
};

export default TitleInput;
